module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-page"
  }, [_c('div', {
    ref: "banner",
    staticClass: "banner"
  }, [_c('app-swiper', {
    attrs: {
      "language": _vm.language
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-section"
  }, [_c('div', {
    staticClass: "tab-main"
  }, [_c('ul', {
    staticClass: "outer"
  }, [_c('li', {
    staticClass: "outer-item show-detail"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon1",
    attrs: {
      "src": require("assets/main-page/home_icon_01@3x.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainWhatWan")))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhatWanDefined")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhatWanGlobal")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhatWanConnection")))])])])]), _vm._v(" "), _c('li', {
    staticClass: "outer-item"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon2",
    attrs: {
      "src": require("assets/main-page/home_icon_02@3x.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainWhyWan")))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "push": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.jumpRouter()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhyWanHeight")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhyWanStrong")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainWhyWanFlexible")))])])])]), _vm._v(" "), _c('li', {
    staticClass: "p4 outer-item"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon1",
    attrs: {
      "src": require("assets/main-page/home_icon_03@3x.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainCloud")))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudSaas")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudApp")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudSoho")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudRemote")))])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.language == 'ch'),
      expression: "language == 'ch'"
    }],
    staticClass: "p4 outer-item"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon1",
    attrs: {
      "src": require("assets/main-page/home_icon_04@3x.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainCloud1")))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainGlobal")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainData")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainSafeData")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainSimple")))])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.language == 'en'),
      expression: "language == 'en'"
    }],
    staticClass: "p4 outer-item"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showTabDetail
      }),
      expression: "{ methods: showTabDetail }"
    }],
    staticClass: "top-travel clear"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    staticClass: "icon icon1",
    attrs: {
      "src": require("assets/main-page/home_icon_04@3x.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainCloudConnection")))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudBranch")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudData")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudSecured")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainCloudEasy")))])]), _vm._v(">\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "feature-section"
  }, [_c('div', {
    staticClass: "gradient"
  }, [_c('div', {
    staticClass: "top-text-contain"
  }, [_c('h1', {
    staticClass: "top-title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainFeatures")))]), _vm._v(" "), _c('div', {
    staticClass: "middle-title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainFeaturesWe")))]), _vm._v(" "), _c('p', {
    staticClass: "bottom-text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainFeaturesBuild")))])]), _vm._v(" "), _c('div', {
    staticClass: "feature-classify"
  }, [_c('ul', {
    staticClass: "all-item clear"
  }, [_c('li', {
    staticClass: "item fl"
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainPERFORMANCE")))])]), _vm._v(" "), _c('li', {
    staticClass: "item fr"
  }, [_vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainSECURITY")))])])]), _vm._v(" "), _c('ul', {
    staticClass: "all-item clear"
  }, [_c('li', {
    staticClass: "item fl"
  }, [_vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainRELIABILITY")))])]), _vm._v(" "), _c('li', {
    staticClass: "item fr"
  }, [_vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainSMART")))])])]), _vm._v(" "), _c('ul', {
    staticClass: "all-item clear"
  }, [_c('li', {
    staticClass: "item fl"
  }, [_vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainEASY")))])]), _vm._v(" "), _c('li', {
    staticClass: "item fr"
  }, [_vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainREAL")))])])]), _vm._v(" "), _c('ul', {
    staticClass: "all-item clear"
  }, [_c('li', {
    staticClass: "item fl"
  }, [_vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainANALYTICS")))])]), _vm._v(" "), _c('li', {
    staticClass: "item fr"
  }, [_vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainFlexible")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "classify-detail"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("language.mainShowMore")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.showFeaturesDetail
      }),
      expression: "{ methods: showFeaturesDetail }"
    }],
    staticClass: "expand-img"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_btn_pop@3x.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "feature-detail"
  }, [_c('div', {
    staticClass: "top-contain"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainFeatures")))])]), _vm._v(" "), _c('div', {
    staticClass: "classify-contain"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.hideFeaturesDetail
      }),
      expression: "{ methods: hideFeaturesDetail }"
    }],
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_btn_back@3x.png")
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "classify-list"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainPERFORMANCE")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainPERFORMANCEDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainSECURITY")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainRELIABILITYDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainRELIABILITY")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainSECURITYDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainSMART")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainSMARTDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainEASY")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainEASYDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainREAL")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainREALDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainANALYTICS")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainANALYTICSDetail")))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("language.mainFlexible")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("language.mainFlexibleDetail")))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "application-section"
  }, [_c('div', {
    staticClass: "text-contain"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainGlobalImprove")))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainGlobalSaas")))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/product/global'
      },
      "push": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("language.mainClickShowMore")))])])], 1)]), _vm._v(" "), _vm._m(13), _vm._v(" "), (_vm.language == 'en') ? _c('div', {
    staticClass: "text-contain"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainGlobalEnterprise")))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("language.mainGlobalWith")))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/product/global'
      },
      "push": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("language.mainClickShowMore")))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.language == 'en') ? _c('div', {
    staticClass: "img-contain"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_img_02@3x.jpg")
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "world-section"
  }, [_c('div', {
    staticClass: "title-contain"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainWorldwide")))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("language.mainSmart")))])]), _vm._v(" "), _c('img', {
    staticClass: "world-img",
    attrs: {
      "src": require("assets/main-page/home_img_03@3x.png")
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('img', {
    staticClass: "icons",
    attrs: {
      "src": require("assets/main-page/home_img_04@3x.png")
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": require("assets/main-page/home_btn_default@3x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": require("assets/main-page/home_btn_default@3x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": require("assets/main-page/home_btn_default@3x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": require("assets/main-page/home_btn_default@3x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-contain fr"
  }, [_c('img', {
    staticClass: "trangle",
    attrs: {
      "src": require("assets/main-page/home_btn_default@3x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_icon_01@3x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "img2",
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_icon_02@3x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_icon_03@3x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "img4",
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_icon_04@3x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "img5",
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_icon_05@3x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_icon_06@3x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_icon_07@3x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_ourfeatures_icon_08@3x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-contain"
  }, [_c('img', {
    attrs: {
      "src": require("assets/main-page/home_img_01@3x.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "world-text"
  }, [_c('p', [_vm._v("HQ/DC")]), _vm._v(" "), _c('p', [_vm._v("Branch Office")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-952ee366","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainPage.vue
// module id = 116
// module chunks = 49